module.exports = __webpack_public_path__ + "static/media/Ted2.89831213.JPG";